import React, { useContext } from 'react';
import {
  Typography, Radio,
} from 'vindi-ds-components';
import { ProductContext } from '../contexts/product_context';

function ProductType() {
  const { handleTypeChange, value: valueState } = useContext(ProductContext);

  return (
    <>
      <Typography variant='subtitle2' component='h3' style={{ marginTop: '1.125em' }}>Tipo de Produto</Typography>
      <ProductTypeRadio title='Produto recorrente' value='recurrent' onClick={handleTypeChange} selectedValue={valueState === 'recurrent' ? 'recurrent' : null} />
      <ProductTypeRadio title='Produto avulso' value='separate' onClick={handleTypeChange} selectedValue={valueState === 'separate' ? 'separate' : null} />
    </>
  );
}

const ProductTypeRadio = ({
  title, value, selectedValue, onClick,
}) => (
  <Radio name={value} value={value} placement='start' id={value} selectedValue={selectedValue} onClick={(e) => onClick(e)}>
    <Typography variant='body2'>{title}</Typography>
  </Radio>
);

export default ProductType;
